import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=3c61aa62&"
import script from "./SessionCard.vue?vue&type=script&lang=ts&"
export * from "./SessionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports